import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminUserAdminCreateComponent } from "./admin-user-admin-create.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzButtonModule } from "ng-zorro-antd/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzInputModule } from "ng-zorro-antd/input";
import { TranslateModule } from "@ngx-translate/core";
import { NzSelectModule } from "ng-zorro-antd/select";

@NgModule({
  declarations: [AdminUserAdminCreateComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzModalModule,
    NzButtonModule,
    FormsModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzSelectModule,
    ReactiveFormsModule,
  ],
  exports: [AdminUserAdminCreateComponent],
})
export class AdminUserAdminCreateModule {}
